import { render, staticRenderFns } from "./Versionupdate.vue?vue&type=template&id=7fc7d26f&"
import script from "./Versionupdate.vue?vue&type=script&lang=js&"
export * from "./Versionupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports